
import { Component, Prop, Vue } from "vue-property-decorator";
import Home from "@/views/Home.vue";
import TSViews from "@/views/TSViews";

@Component({
  components: {
    Home
  }
})
export default class HelloWorld extends Vue {
  $refs!: {
    app: HTMLElement;
  };

  mounted() {
    // this.setAppSize();
    TSViews.bindKey();
  }

  private setAppSize() {
    this.$refs.app.style.height = `${window.innerHeight - 30}px`;
    this.$refs.app.style.width = `${window.innerWidth}px`;
  }
}
